import { render, staticRenderFns } from "./REST.vue?vue&type=template&id=1ae05866&"
import script from "./REST.vue?vue&type=script&lang=js&"
export * from "./REST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports